export var isDev = (process.env.NODE_ENV === 'development' ||
    location.hostname.includes("localhost") ||
    location.hostname.includes("192.168.0.") ||
    location.hostname.includes("test.app."));
export var isLocalhost = (process.env.NODE_ENV === 'development' ||
    location.hostname.includes("localhost") ||
    location.hostname.includes("192.168.0."));
